import * as React from 'react'
import InputWrapper from './InputWrapper'

interface ITextAreaProps {
  title?: string
  name: string
  optional?: boolean
  error?: string
  className: string
  isTouched?: boolean
  onChange: (e: any) => void
  value: string
  classNameContainer?: string
  placeholder?: string
}

const TextArea = (props: ITextAreaProps) => {
  const { classNameContainer, ...rest } = props

  return (
    <InputWrapper {...rest} className={props.classNameContainer}>
      <textarea
        value={props.value}
        name={props.name}
        className={props.className}
        onChange={props.onChange}
        placeholder={props.placeholder}
      />
    </InputWrapper>
  )
}

export default TextArea



// WEBPACK FOOTER //
// ./src/components/ui/TextArea.tsx